/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState, useContext, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import LogoImg from '../../../assets/login/logo.png'
import { Logo } from './style'

import {
  Img,
  Container,
  MainText,
  LoginForm,
  Label,
  TextInput,
  InputButton,
} from './style'
import axios from '../../../config/axios'
import UserContext from '../../../contexts/UserContext'
import jwtDecode from 'jwt-decode'

function CompleteRegister() {
  const [phone, setPhone] = useState<string>('')
  const [company, setCompany] = useState<string>('')
  const [cnpj, setCnpj] = useState<string>('')
  const { googleEmail, googleName, googlePicture, setUser, user } =
    useContext(UserContext)
  const { token } = useParams()
  const [valid, setValid] = useState<boolean>(false)

  useEffect(() => {
    if (token == undefined) {
      setValid(false)
    } else {
      tryToken(token)
    }
  }, [token])

  const tryToken = async (token: string) => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/new-admin/${token}`,
      )
      setValid(response.data)
    } catch (error) {
      console.log(error)
      return false
    }
  }

  const handleGoogleRegister = async () => {
    axios
      .post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/backend/google-user`, {
        email: googleEmail,
        password: '',
        name: googleName,
        phone,
        company,
        cnpj,
        picture: googlePicture,
        adminUser: false,
        approved: 'pendent',
      })
      .then((res) => {
        if (user.name !== '') {
          window.location.href = '/pendingmessage'
        }

        console.log(res)
      })
      .catch((err) => {
        console.log(err)
      })
  }

  return (
    <>
      <Img></Img>
      <Container>
        <Logo src={LogoImg} alt='Logo da Dustre' />
        <MainText>Finalize seu cadastro</MainText>

        <LoginForm>
          <Label htmlFor='phone'>Telefone para contato</Label>
          <TextInput
            type='string'
            name='phone'
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />

          <Label htmlFor='company'>Empresa</Label>
          <TextInput
            type='text'
            name='company'
            value={company}
            onChange={(e) => setCompany(e.target.value)}
          />

          <Label htmlFor='cnpj'>CNPJ</Label>
          <TextInput
            type='text'
            name='cnpj'
            value={cnpj}
            onChange={(e) => setCnpj(e.target.value)}
          />

          <InputButton
            onClick={handleGoogleRegister}
            type='button'
            value='Cadastrar'
            disabled={!(phone && company && cnpj)}
          />
        </LoginForm>
      </Container>
    </>
  )
}

export default CompleteRegister
